import Raven from 'raven-js';

type MaybeWindowHubspotBender = {
  hubspot?: {
    bender?: {
      currentProject?: string;
    };
  };
};

export function throwCommandError(errorMessage: string) {
  const error = new Error(errorMessage);
  console.warn(errorMessage);
  Raven.captureException(error, {
    fingerprint: [
      errorMessage,
      (window as MaybeWindowHubspotBender).hubspot?.bender?.currentProject ||
        'unknown-project',
    ],
  });
}
